import { map, get, find, isEqual, compact, intersection } from '../nodash';

import { sortProductsByColorWheel } from '../../lib/collection';
import { getMetafieldTags } from '../../lib/product';

import Fuse from 'fuse.js';

const fuseOptions = {
  includeScore: true,
  keys: ['name', 'title'],
  minMatchCharLength: 1,
  threshold: 0.2,
};

const filteredPaintCollections = ({
  paintCollections,
  paintCollectionArrangement = [],
  sorts,
  filterQuery,
  filterTags,
  colorWheel,
  shopifyProducts,
}) => {
  const sortByColorWheel =
    find({ id: 'colorIndex' }, sorts) || find({ slug: 'colorIndex' }, sorts);
  const fuse = new Fuse(paintCollections, fuseOptions);
  const nameMatches = fuse.search(filterQuery || '');

  const collections = paintCollections
    .map((collection) => {
      const hasProducts =
        compact(map('id', get('products', collection))).length > 0;
      return hasProducts
        ? collection
        : {
            ...collection,
            products: map(
              (p) => find({ shopifyId: get('shopifyId', p) }, shopifyProducts),
              collection.products
            ),
          };
    })
    .filter((x) => {
      if (filterTags.length === 0 && (!filterQuery || filterQuery === '')) {
        return true;
      }

      // name search
      if (filterQuery && filterQuery !== '') {
        return find(
          (z) => isEqual(get('shopifyId', x), get('item.shopifyId', z)),
          nameMatches
        );
      }

      // tag filter
      const tags = getMetafieldTags(x.metafields);
      return intersection(map('slug', filterTags), tags).length > 0;
    })
    .sort((a, b) => {
      const aMatch = nameMatches.find((x) => x.item.id === a.id);
      const bMatch = nameMatches.find((x) => x.item.id === b.id);
      return (aMatch?.score || 0) - (bMatch?.score || 0);
    });

  return nameMatches.length > 0
    ? collections
    : sortByColorWheel
    ? sortProductsByColorWheel(colorWheel, collections)
    : collections.sort((a, b) => {
        return (
          paintCollectionArrangement.indexOf(get('shopifyId', a)) -
          paintCollectionArrangement.indexOf(get('shopifyId', b))
        );
      });
};

export default filteredPaintCollections;
